import NavigationList from "@service/components/navbar/NavigationList.vue";
import NavigationItem from "@service/components/navbar/NavigationItem.vue";

export class ActiveTabHelper {
    public readonly navigationItemsRefKey = 'navigationItems';
    private _underscoreParams = {
        left: 0,
        width: 0
    };
    isHovering = false;

    constructor(
        private readonly component: NavigationList
    ) {}

    get underscoreParams() {
        return this._underscoreParams;
    }

    get underscoreStyles() {
        return {
            left: `${this.underscoreParams.left}px`,
            width: `${this.underscoreParams.width}px`
        }
    }

    getActiveNavigationItem() {
        if (this.component.$refs[this.navigationItemsRefKey]) {
            return (this.component.$refs[this.navigationItemsRefKey] as NavigationItem[]).find(item => item.isActive);
        }

        return null;
    }

    setUnderscoreToActive() {
        const activeNavigationItem = this.getActiveNavigationItem();

        this._underscoreParams = {
            left: (activeNavigationItem?.$el as HTMLElement).offsetLeft ?? 0,
            width: (activeNavigationItem?.$el as HTMLElement).clientWidth ?? 0
        }
    }

    onMouseOver(element: HTMLElement) {
        this.isHovering = true;

        this._underscoreParams = {
            left: element.offsetLeft,
            width: element.clientWidth
        }
    }

    onMouseLeave() {
        this.setUnderscoreToActive();
        this.isHovering = false;
    }
}